// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/certificate-of-airworthiness-conditions.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/certificate-of-airworthiness-conditions/certificate-of-airworthiness-conditions.js';

mount([g0]);
